import { useState } from "react";
import { CHORDS, CHORD_PROGRESSION, PATTERN } from "./constants";
import { createPluckSound, createSteelpanSound } from "./audio";

// 不協和音用の周波数倍率
const DISSONANCE_RATIO = 1.05946; // 半音の1/10

/**
 * すべての必要な音を事前生成する
 * @returns {Promise<void>}
 */
export const initializeSounds = async () => {
  console.log("Pre-generating sounds...");

  // AudioContextの初期化確認
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  if (audioContext.state === "suspended") {
    console.log("AudioContext is suspended. Will resume on user interaction.");
  }

  // 各コード進行に対して音を生成
  for (const chord of CHORD_PROGRESSION) {
    // パターン内の各音を生成
    for (const [noteIndex] of PATTERN) {
      if (noteIndex !== -1) {
        // 通常の音
        await createPluckSound(CHORDS[chord][noteIndex]);
        // 不協和音バージョン
        await createPluckSound(CHORDS[chord][noteIndex] * DISSONANCE_RATIO);
      }
    }

    // スティールパン音（ルート音の1オクターブ上）
    const rootFrequency = CHORDS[chord][2] * 2;
    await createSteelpanSound(rootFrequency);
    // 不協和音バージョン
    await createSteelpanSound(rootFrequency * DISSONANCE_RATIO);
  }

  console.log("Sounds ready.");
};

/**
 * サウンド初期化の状態を管理するフック
 * @returns {{isInitialized: boolean, initializeSounds: Function}}
 */
export const useSoundInitializer = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);

  const initialize = async () => {
    if (isInitialized || isInitializing) return;

    setIsInitializing(true);
    try {
      await initializeSounds();
      setIsInitialized(true);
    } catch (error) {
      console.error("Failed to initialize sounds:", error);
    } finally {
      setIsInitializing(false);
    }
  };

  return {
    isInitialized,
    isInitializing,
    initialize,
  };
};
